<template>
  <span
    :data-cell_uuid="cell_uuid"
    :class="{ 'is-error': isError }"
    :title="title"
    class="b-editor-excel-cell"
    @click="onClick"
    v-text="label"
  />
</template>

<script>
import { EXCEL_CELL_ERROR_LABEL } from '@/helpers/enums/params'


export default {
  name: 'BEditorExcelCell',
  inheritAttrs: false,
  props: {
    // props from https://git.io/JqeWT
    editor: {
      type: Object,
      required: true,
    },
    node: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
      validate: (prop) => 'currentSheet' in prop && 'sheetTree' in prop,
    },
    updateAttrs: Function,

    // extension: null,
    // parent: null,
    // view: null,
    // getPos: null,
    // decorations: null,
  },
  computed: {
    cell_uuid() {
      return this.node.attrs.cell_uuid
    },
    cell() {
      const { cell_uuid: uuid } = this
      const { $all_cells } = this.options.sheetTree
      return $all_cells.find((_) => _.uuid === uuid)
    },
    label() {
      if (!this.cell) return EXCEL_CELL_ERROR_LABEL
      const sheet = this.cell.$parent.$data
      const cell = this.cell.$data
      return cell ? `${sheet.code}:${cell.code}` : EXCEL_CELL_ERROR_LABEL
    },
    title() {
      if (!this.cell) return EXCEL_CELL_ERROR_LABEL
      const sheet = this.cell.$parent.$data
      const cell = this.cell.$data
      return cell ? `${sheet.name} (${cell.name})` : EXCEL_CELL_ERROR_LABEL
    },
    isError() {
      return this.label === EXCEL_CELL_ERROR_LABEL
    },
  },
  watch: {
    label(value, oldValue) {
      if (value === oldValue) return
      const cell_uuid = value === EXCEL_CELL_ERROR_LABEL ? EXCEL_CELL_ERROR_LABEL : value
      this.updateAttrs({ cell_uuid })
    },
  },
  methods: {
    onClick() {
      const { excel_cell } = this
      this.$emit('excel_cell', { excel_cell })
    },
  },
}
</script>

<style lang="scss">
.b-editor-excel-cell {
  padding: 0.2rem 0.5rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  &.is-error {
    color: $color-error;
    background-color: rgba($color-error, 0.3);
  }
}
</style>
